import React from 'react';
import PropTypes from 'prop-types';
import {
  PieChart,
  Pie,
  Tooltip,
  ResponsiveContainer,
  Legend,
  Cell,
} from 'recharts';
import { chartTheme } from './chartTheme';

const PieChartCompletion = ({ data }) => {
  if (!data || !data.sections) return null;

  const totalCompleted = data.sections.reduce(
    (sum, item) => sum + item.totalAssignmentsCompleted,
    0,
  );
  const totalMissed = data.sections.reduce(
    (sum, item) => sum + item.totalAssignmentsMissed,
    0,
  );
  const totalAssignments = totalCompleted + totalMissed || 1;

  const percentCompleted = ((totalCompleted / totalAssignments) * 100).toFixed(
    1,
  );
  const percentMissed = ((totalMissed / totalAssignments) * 100).toFixed(1);

  const pieData = [
    {
      name: `Completed Assignments (${percentCompleted}%)`,
      value: totalCompleted,
      color: chartTheme.main,
    },
    {
      name: `Missed Assignments (${percentMissed}%)`,
      value: totalMissed,
      color: chartTheme.secondary,
    },
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        minWidth: '400px',
      }}
    >
      <h3>Overall Assignment Completion</h3>

      <p
        style={{
          fontSize: '14px',
          color: 'gray',
          textAlign: 'center',
          maxWidth: '80%',
          marginBottom: '10px',
        }}
      >
        This chart shows the overall distribution of completed and missed
        assignments across all sections.{' '}
        <b>{percentMissed}% of assignments were missed</b>, while
        <b> {percentCompleted}% were successfully completed.</b>
      </p>

      <ResponsiveContainer width="50%" height={300}>
        <PieChart>
          <Tooltip formatter={(value) => `${value} assignments`} />
          <Legend wrapperStyle={{ fontSize: '14px', marginBottom: '10px' }} />
          <Pie
            data={pieData}
            dataKey="value"
            nameKey="name"
            cx="50%"
            cy="50%"
            outerRadius={100}
          >
            {pieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default PieChartCompletion;

PieChartCompletion.propTypes = {
  data: PropTypes.shape({
    sections: PropTypes.arrayOf(
      PropTypes.shape({
        totalAssignmentsCompleted: PropTypes.number,
        totalAssignmentsMissed: PropTypes.number,
      }),
    ),
  }).isRequired,
};
